"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TITLE_OPTIONS = exports.TITLE_DATA_STANDARDS = void 0;
var _Input = _interopRequireDefault(require("../../elements/input/Input"));
var _Select = _interopRequireDefault(require("../../elements/select/Select"));
var _restrictInput = require("../normalizers/restrictInput");
var _regex = _interopRequireWildcard(require("../regex"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TITLE = {
  component: _Input["default"],
  name: 'title',
  label: 'Title',
  id: 'title',
  type: 'text',
  className: 'fieldSmall',
  required: true,
  maxLength: 10,
  regex: (0, _regex["default"])(_regex.lettersDotPattern),
  validationMessageKeys: {
    required: 'Please enter a title',
    maxLength: 'Sorry, you’ve entered a title longer than we can accept',
    regex: 'Please remove the invalid characters to continue'
  },
  normalize: _restrictInput.excludeSymbolsTitle,
  autoComplete: 'honorific-prefix'
};
var _default = exports["default"] = TITLE;
var TITLE_OPTIONS = exports.TITLE_OPTIONS = [{
  value: '',
  label: 'Select a title'
}, {
  value: 'Mr',
  label: 'Mr'
}, {
  value: 'Mrs',
  label: 'Mrs'
}, {
  value: 'Miss',
  label: 'Miss'
}, {
  value: 'Ms',
  label: 'Ms'
}, {
  value: 'Mx',
  label: 'Mx'
}, {
  value: 'Dr',
  label: 'Dr'
}, {
  value: 'Lord',
  label: 'Lord'
}, {
  value: 'Lady',
  label: 'Lady'
}, {
  value: 'Prof',
  label: 'Prof'
}, {
  value: 'Reverend',
  label: 'Reverend'
}, {
  value: 'Sir',
  label: 'Sir'
}, {
  value: 'Dame',
  label: 'Dame'
}];
var TITLE_DATA_STANDARDS = exports.TITLE_DATA_STANDARDS = {
  component: _Select["default"],
  name: 'title',
  id: 'title',
  label: 'Title',
  options: TITLE_OPTIONS,
  required: false,
  validationMessageKeys: {
    required: 'Please select a title'
  }
};